import { render, staticRenderFns } from "./camera-photo.vue?vue&type=template&id=3812fefc&"
import script from "./camera-photo.vue?vue&type=script&lang=js&"
export * from "./camera-photo.vue?vue&type=script&lang=js&"
import style0 from "./camera-photo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports